/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ organizationId: ZodTypes.Id });

export const DeleteOrganizationThumbnail = {
  id: 'organization-thumbnail.delete',
  tag: 'Organization',
  summary: 'Delete organization thumbnail',
  description: 'Delete an organization thumbnail',
  method: 'delete',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/thumbnail`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
